import { css } from '@emotion/react';

export const mapArea = css`
    display: flex;
    flex: 1;
    border-radius: 12px;
    overflow: hidden;
    position: relative;

    .ol-zoom {
        position: absolute;
        background-color: rgba(255, 255, 255, 0.4);
        border-radius: 4px;
        padding: 2px;
        top: 1em;
        right: 1em;
    }

    .ol-control button {
        display: flex;
        margin: 1px;
        font-size: 12px;
        font-weight: bold;
        justify-content: center;
        text-align: center;
        height: 16px;
        width: 16px;
        border: none;
        color: black;
        background-color: white;
    }

    .ol-zoom-in {
        border-radius: 2px 2px 0px 0px;
    }

    .ol-zoom-out {
        border-radius: 0px 0px 2px 2px;
    }

    .ol-rotate {
        display: none;
    }

    .ol-popup {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        background-color: white;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        border: 1px solid #cccccc;
        bottom: 12px;
        left: -50px;
        width: 170px;
        height: 60px;
    }
    .ol-popup:after,
    .ol-popup:before {
        top: 100%;
        border: solid transparent;
        content: ' ';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }
    .ol-popup:after {
        border-top-color: white;
        border-width: 10px;
        left: 48px;
        margin-left: -10px;
    }
    .ol-popup:before {
        border-top-color: #cccccc;
        border-width: 11px;
        left: 48px;
        margin-left: -11px;
    }

    #date {
        position: absolute;
        bottom: 1em;
        left: 1em;
        color: white;
        -webkit-text-stroke: 1px black;
        font-size: 2em;
        font-weight: bold;
    }
`;

export const mapContainer = css`
    display: flex;
    width: 100%;
    height: 790px;
    border-radius: 12px;
`;

export const subMap = css`
    margin-left: 10px;
`;

export const layerOptionContainer = css`
    display: flex;
    height: 25px;
    align-items: center;
    justify-content: space-around;
`;

export const option = css`
    display: flex;
    align-items: center;
`;

export const optionName = css`
    padding: 10px;
`;
